<div class="main-content mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 2 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-reg"
          routerLink="/marketing/social/contentRequests"
          >Content Requests
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          routerLink="/marketing/social/registry"
          >Social Registry
        </a>
      </div>
    </div>
  </div> -->

    <div class="row mb-4 mt-2 text-center">
      <div class="col-12">
        <div class="platform-cards-container">
          <!-- Instagram -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'instagram' }"
            (click)="
              filters.platform =
                filters.platform === 'instagram' ? '' : 'instagram';
              applyFilters()
            "
          >
            <div class="platform-icon ig">
              <i class="fab fa-instagram"></i>
            </div>
            <span class="platform-name">Instagram</span>
          </div>

          <!-- Facebook -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'facebook' }"
            (click)="
              filters.platform =
                filters.platform === 'facebook' ? '' : 'facebook';
              applyFilters()
            "
          >
            <div class="platform-icon fb">
              <i class="fab fa-facebook-f"></i>
            </div>
            <span class="platform-name">Facebook</span>
          </div>

          <!-- YouTube -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'youtube' }"
            (click)="
              filters.platform =
                filters.platform === 'youtube' ? '' : 'youtube';
              applyFilters()
            "
          >
            <div class="platform-icon yt">
              <i class="fab fa-youtube"></i>
            </div>
            <span class="platform-name">YouTube</span>
          </div>

          <!-- TikTok -->
          <div
            class="platform-card"
            [ngClass]="{ active: filters.platform === 'tiktok' }"
            (click)="
              filters.platform = filters.platform === 'tiktok' ? '' : 'tiktok';
              applyFilters()
            "
          >
            <div class="platform-icon tt">
              <i class="fab fa-tiktok"></i>
            </div>
            <span class="platform-name">TikTok</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3 mt-4">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a
            class="btn btn-dark btn-sm btn-new"
            routerLink="/marketing/social/strategy"
            >STRATEGY
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            routerLink="/marketing/social/semantika"
            >SEMANTIKA
          </a>
          <!-- <a class="btn btn-dark btn-sm btn-reg">PERFORMANCE </a> -->
          <a class="btn btn-dark btn-sm btn-new">NOTES </a>
        </div>
      </div>
    </div>

    <div class="semantika-container p-4" *ngIf="!loading">
      <!-- ── HEADER ─────────────────────────────────────────────────────── -->
      <div class="d-flex justify-content-between align-items-start mb-4">
        <div>
          <h2 class="h4 fw-bold text-dark d-flex align-items-center mb-1">
            Performance
            <i
              class="fas fa-info-circle ms-2 text-muted"
              style="font-size: 1rem"
            ></i>
          </h2>
          <p class="text-dark small mb-0 fw-medium">
            Verified results and KPIs for Facebook. All data is governed by
            Global Performance Authority.
          </p>
        </div>
        <div class="text-end">
          <div class="d-flex align-items-center justify-content-end mb-1">
            <span class="fw-bold text-dark me-2 small">Data Status</span>
            <span class="text-success small fw-bold d-flex align-items-center">
              <i class="fas fa-circle me-1" style="font-size: 8px"></i> Verified
            </span>
          </div>
          <div class="text-muted small">Last update: May 12, 2025 08:30 AM</div>
        </div>
      </div>

      <!-- ── FILTERS ────────────────────────────────────────────────────── -->
      <div>
        <label
          class="text-dark d-flex align-items-center mb-2"
          for="timeControls"
          ><i class="fas fa-sliders-h text-primary me-2"></i
          ><strong>Time Controls</strong></label
        >
      </div>
      <div class="filters-scroll-wrapper custom-scroll-x mb-0">
        <div class="filters-inline-row">
          <!-- Cadence -->
          <div class="filter-card">
            <label class="form-label small fw-bold text-dark mb-1 d-block"
              >Cadence</label
            >
            <select
              class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
            >
              <option>Monthly</option>
            </select>
          </div>

          <!-- Period -->
          <div class="filter-card">
            <label class="form-label small fw-bold text-dark mb-1 d-block"
              >Period</label
            >
            <select
              class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
            >
              <option>Apr 2025</option>
            </select>
          </div>

          <!-- View -->
          <div class="filter-card">
            <label class="form-label small fw-bold text-dark mb-1 d-block"
              >View</label
            >
            <select
              class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
            >
              <option>Executive Summary</option>
            </select>
          </div>

          <!-- Benchmark -->
          <div class="filter-card">
            <label class="form-label small fw-bold text-dark mb-1 d-block"
              >Benchmark</label
            >
            <select
              class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
            >
              <option>Industry: Social Media</option>
            </select>
          </div>

          <!-- Registered Object -->
          <div class="filter-card">
            <label class="form-label small fw-bold text-dark mb-1 d-block"
              >Registered Object</label
            >
            <select
              class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
            >
              <option
                *ngFor="let item of registeredObjects; let i = index"
                [selected]="i === 0"
              >
                {{ item }}
              </option>
            </select>
          </div>

          <div class="ps-3 border-start">
            <button
              class="btn btn-outline-secondary btn-sm d-flex align-items-center fw-semibold mt-4"
              (click)="applyFilters()"
            >
              Find
            </button>
          </div>
        </div>
      </div>

      <!-- ── STATS CARDS ────────────────────────────────────────────────── -->
      <div class="row row-height mb-0 mx-0">
        <div class="col-12 px-0">
          <div
            class="row m-0 align-items-center flex-nowrap custom-scroll-x p-0 gap-3 row-height w-100"
          >
            <!-- Card 1 -->
            <div class="col h-100 p-1" style="min-width: 200px; flex: 1">
              <div
                class="card shadow-sm border-0 bg-white w-100 h-100"
                style="border-radius: 8px"
              >
                <div class="card-body p-2">
                  <div
                    class="d-flex justify-content-start align-items-start mb-2"
                  >
                    <div
                      class="text-uppercase text-dark fw-bold d-flex align-items-center"
                      style="font-size: 0.75rem"
                    >
                      <i
                        class="fas fa-users text-primary me-2 shadow-sm rounded-circle p-1 bg-primary-light"
                      ></i>
                      <strong>Total Reach</strong>
                    </div>
                  </div>
                  <h3 class="mt-2 mb-1 fw-bold text-dark">
                    <strong>2.45M</strong>
                  </h3>
                  <div class="text-muted small mb-2" style="font-size: 0.7rem">
                    vs Mar 2025
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between mt-2 pt-1"
                  >
                    <div
                      class="small fw-bold text-success"
                      style="font-size: 0.8rem"
                    >
                      <i class="fas fa-arrow-up"></i> 12.6%
                    </div>
                    <div class="sparkline-chart">
                      <svg width="60" height="20">
                        <path
                          d="M0,20 L15,10 L30,15 L45,5 L60,0"
                          fill="none"
                          stroke="#28a745"
                          stroke-width="2"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card 2 -->
            <div class="col h-100 p-1" style="min-width: 200px; flex: 1">
              <div
                class="card shadow-sm border-0 bg-white w-100 h-100"
                style="border-radius: 8px"
              >
                <div class="card-body p-2">
                  <div
                    class="d-flex justify-content-start align-items-start mb-2"
                  >
                    <div
                      class="text-uppercase text-dark fw-bold d-flex align-items-center"
                      style="font-size: 0.75rem"
                    >
                      <i
                        class="fas fa-user-check text-purple me-2 shadow-sm rounded-circle p-1"
                        style="color: #6f42c1; background-color: #e0d4f5"
                      ></i>
                      <strong>Engagement Rate</strong>
                    </div>
                  </div>
                  <h3 class="mt-2 mb-1 fw-bold text-dark">
                    <strong>4.32%</strong>
                  </h3>
                  <div class="text-muted small mb-2" style="font-size: 0.7rem">
                    vs Mar 2025
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between mt-2 pt-1"
                  >
                    <div
                      class="small fw-bold text-success"
                      style="font-size: 0.8rem"
                    >
                      <i class="fas fa-arrow-up"></i> 8.7%
                    </div>
                    <div class="sparkline-chart">
                      <svg width="60" height="20">
                        <path
                          d="M0,20 L15,15 L30,5 L45,15 L60,0"
                          fill="none"
                          stroke="#6f42c1"
                          stroke-width="2"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card 3 -->
            <div class="col h-100 p-1" style="min-width: 200px; flex: 1">
              <div
                class="card shadow-sm border-0 bg-white w-100 h-100"
                style="border-radius: 8px"
              >
                <div class="card-body p-2">
                  <div
                    class="d-flex justify-content-start align-items-start mb-2"
                  >
                    <div
                      class="text-uppercase text-dark fw-bold d-flex align-items-center"
                      style="font-size: 0.75rem"
                    >
                      <i
                        class="fas fa-comments text-info me-2 shadow-sm rounded-circle p-1 bg-info-light"
                        style="background-color: #d1ecf1"
                      ></i>
                      <strong>Total Interactions</strong>
                    </div>
                  </div>
                  <h3 class="mt-2 mb-1 fw-bold text-dark">
                    <strong>105.8K</strong>
                  </h3>
                  <div class="text-muted small mb-2" style="font-size: 0.7rem">
                    vs Mar 2025
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between mt-2 pt-1"
                  >
                    <div
                      class="small fw-bold text-success"
                      style="font-size: 0.8rem"
                    >
                      <i class="fas fa-arrow-up"></i> 15.3%
                    </div>
                    <div class="sparkline-chart">
                      <svg width="60" height="20">
                        <path
                          d="M0,20 L15,18 L30,12 L45,8 L60,0"
                          fill="none"
                          stroke="#007bff"
                          stroke-width="2"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card 4 -->
            <div class="col h-100 p-1" style="min-width: 200px; flex: 1">
              <div
                class="card shadow-sm border-0 bg-white w-100 h-100"
                style="border-radius: 8px"
              >
                <div class="card-body p-2">
                  <div
                    class="d-flex justify-content-start align-items-start mb-2"
                  >
                    <div
                      class="text-uppercase text-dark fw-bold d-flex align-items-center"
                      style="font-size: 0.75rem"
                    >
                      <i
                        class="fas fa-eye text-primary me-2 shadow-sm rounded-circle p-1 bg-primary-light"
                        style="background-color: #cce5ff; color: #0056b3"
                      ></i>
                      <strong>Impressions</strong>
                    </div>
                  </div>
                  <h3 class="mt-2 mb-1 fw-bold text-dark">
                    <strong>5.62M</strong>
                  </h3>
                  <div class="text-muted small mb-2" style="font-size: 0.7rem">
                    vs Mar 2025
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between mt-2 pt-1"
                  >
                    <div
                      class="small fw-bold text-success"
                      style="font-size: 0.8rem"
                    >
                      <i class="fas fa-arrow-up"></i> 9.1%
                    </div>
                    <div class="sparkline-chart">
                      <svg width="60" height="20">
                        <path
                          d="M0,20 L15,10 L30,18 L45,5 L60,10"
                          fill="none"
                          stroke="#17a2b8"
                          stroke-width="2"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card 5 -->
            <div class="col h-100 p-1" style="min-width: 200px; flex: 1">
              <div
                class="card shadow-sm border-0 bg-white w-100 h-100"
                style="border-radius: 8px"
              >
                <div class="card-body p-2">
                  <div
                    class="d-flex justify-content-start align-items-start mb-2"
                  >
                    <div
                      class="text-uppercase text-dark fw-bold d-flex align-items-center"
                      style="font-size: 0.75rem"
                    >
                      <i
                        class="fas fa-mouse-pointer text-warning me-2 shadow-sm rounded-circle p-1 bg-warning-light"
                        style="background-color: #fff3cd; color: #d39e00"
                      ></i>
                      <strong>Link Clicks</strong>
                    </div>
                  </div>
                  <h3 class="mt-2 mb-1 fw-bold text-dark">
                    <strong>18.7K</strong>
                  </h3>
                  <div class="text-muted small mb-2" style="font-size: 0.7rem">
                    vs Mar 2025
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between mt-2 pt-1"
                  >
                    <div
                      class="small fw-bold text-success"
                      style="font-size: 0.8rem"
                    >
                      <i class="fas fa-arrow-up"></i> 11.4%
                    </div>
                    <div class="sparkline-chart">
                      <svg width="60" height="20">
                        <path
                          d="M0,20 L15,10 L30,12 L45,5 L60,0"
                          fill="none"
                          stroke="#fd7e14"
                          stroke-width="2"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ── ROW 3: MAIN LAYOUT ─────────────────────────────────────────── -->
      <!-- Left Column: Charts and Breakdowns -->
      <div class="row mb-3">
        <!-- Performance Over Time -->
        <div class="col-lg-5 mb-3 mb-lg-0 pr-0">
          <div
            class="card shadow-sm h-100 border-0 p-3"
            style="border-radius: 8px"
          >
            <div class="d-flex justify-content-between align-items-center mb-4">
              <h4 class="fw-bold text-dark mb-0">
                <strong>Performance Over Time</strong>
              </h4>
              <select
                class="form-select form-select-sm border shadow-none text-muted fw-bold"
                style="width: 120px; font-size: 0.75rem"
              >
                <option>Total Reach</option>
              </select>
            </div>
            <div
              class="chart-container"
              style="
                min-height: 200px;
                display: flex;
                align-items: flex-end;
                justify-content: center;
                position: relative;
                margin-top: 20px;
              "
            >
              <svg
                width="100%"
                height="200"
                viewBox="0 0 400 200"
                preserveAspectRatio="none"
              >
                <!-- Grid lines -->
                <line
                  x1="25"
                  y1="20"
                  x2="400"
                  y2="20"
                  stroke="#f0f0f0"
                  stroke-width="1"
                />
                <line
                  x1="25"
                  y1="60"
                  x2="400"
                  y2="60"
                  stroke="#f0f0f0"
                  stroke-width="1"
                />
                <line
                  x1="25"
                  y1="100"
                  x2="400"
                  y2="100"
                  stroke="#f0f0f0"
                  stroke-width="1"
                />
                <line
                  x1="25"
                  y1="140"
                  x2="400"
                  y2="140"
                  stroke="#f0f0f0"
                  stroke-width="1"
                />
                <line
                  x1="25"
                  y1="180"
                  x2="400"
                  y2="180"
                  stroke="#f0f0f0"
                  stroke-width="1"
                />
                <!-- Y-Axis labels -->
                <text
                  x="20"
                  y="25"
                  font-size="10"
                  fill="#888"
                  text-anchor="end"
                >
                  4M
                </text>
                <text
                  x="20"
                  y="65"
                  font-size="10"
                  fill="#888"
                  text-anchor="end"
                >
                  3M
                </text>
                <text
                  x="20"
                  y="105"
                  font-size="10"
                  fill="#888"
                  text-anchor="end"
                >
                  2M
                </text>
                <text
                  x="20"
                  y="145"
                  font-size="10"
                  fill="#888"
                  text-anchor="end"
                >
                  1M
                </text>
                <text
                  x="20"
                  y="185"
                  font-size="10"
                  fill="#888"
                  text-anchor="end"
                >
                  0
                </text>
                <!-- X-Axis Labels -->
                <text x="35" y="200" font-size="10" fill="#888">Apr 1</text>
                <text x="105" y="200" font-size="10" fill="#888">Apr 8</text>
                <text x="175" y="200" font-size="10" fill="#888">Apr 15</text>
                <text x="245" y="200" font-size="10" fill="#888">Apr 22</text>
                <text x="315" y="200" font-size="10" fill="#888">Apr 29</text>

                <!-- Dashed Line graph for Mar 2025 -->
                <path
                  d="M 35 150 L 65 150 L 95 140 L 125 120 L 155 110 L 185 95 L 215 110 L 245 95 L 275 85 L 305 80 L 335 55 L 365 60 L 395 40"
                  fill="none"
                  stroke="#a0a0a0"
                  stroke-width="1.5"
                  stroke-dasharray="4,4"
                />
                <!-- Line graph for Apr 2025 -->
                <path
                  d="M 35 140 L 65 120 L 95 130 L 125 100 L 155 90 L 185 80 L 215 95 L 245 85 L 275 70 L 305 65 L 335 40 L 365 40 L 395 20"
                  fill="none"
                  stroke="#0d6efd"
                  stroke-width="2"
                />
              </svg>
            </div>
            <div
              class="d-flex justify-content-end mt-2 gap-3 small text-dark fw-bold"
            >
              <div class="d-flex align-items-center">
                <div
                  class="bg-primary rounded me-2"
                  style="width: 12px; height: 3px"
                ></div>
                Apr 2025
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="me-2"
                  style="
                    width: 12px;
                    height: 1px;
                    border-bottom: 2px dashed #a0a0a0;
                  "
                ></div>
                Mar 2025
              </div>
            </div>
          </div>
        </div>

        <!-- Metric Details -->
        <div class="col-lg-4 ps-lg-2 mt-3 mt-lg-0">
          <div
            class="card shadow-sm h-100 border-0 p-3"
            style="border-radius: 8px"
          >
            <h4 class="fw-bold text-dark mb-3">
              <strong>Metric Details</strong>
            </h4>
            <div class="table-responsive">
              <table
                class="table table-borderless table-sm small align-middle mb-0 text-start"
              >
                <thead class="text-dark border-bottom head-table">
                  <tr>
                    <th class="fw-semibold pb-2 pt-0 w-25">Metric</th>
                    <th class="fw-semibold pb-2 pt-0 w-20">Value</th>
                    <th class="fw-semibold pb-2 pt-0 w-20">vs Mar 2025</th>
                    <th class="fw-semibold pb-2 pt-0 w-20 text-center">
                      Status
                    </th>
                    <th class="fw-semibold pb-2 pt-0 text-end">Data Quality</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="border-bottom"
                    *ngFor="let item of metricDetails; let last = last"
                    [ngClass]="{ 'border-bottom-0': last }"
                  >
                    <td class="text-dark fw-semibold py-2">
                      {{ item.metric }}
                    </td>
                    <td class="text-dark">{{ item.value }}</td>
                    <td
                      class="fw-bold"
                      [ngClass]="item.trendUp ? 'text-success' : 'text-danger'"
                    >
                      <i
                        class="fas me-1"
                        [ngClass]="
                          item.trendUp ? 'fa-arrow-up' : 'fa-arrow-down'
                        "
                      ></i
                      >{{ item.trendValue }}
                    </td>
                    <td class="text-center">
                      <span
                        class="badge bg-light text-success border border-success rounded-pill px-2 py-1 bg-opacity-10"
                        style="
                          background-color: #e6f6ee !important;
                          font-weight: 500;
                        "
                      >
                        {{ item.status }}
                      </span>
                    </td>
                    <td class="text-end text-dark fw-semibold">
                      <i
                        class="fas fa-circle me-1"
                        [ngClass]="item.qualityClass"
                        style="font-size: 8px"
                      ></i>
                      {{ item.quality }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-lg-3 ps-lg-3 mt-3 mt-lg-0 px-0">
          <div class="d-flex flex-column h-100">
            <!-- Methodology -->
            <div
              class="card shadow-sm border-0 p-3 mb-3"
              style="border-radius: 8px"
            >
              <h6 class="fw-bold text-dark mb-3">Methodology</h6>
              <p class="text-dark small mb-3 fw-semibold">
                Facebook Performance Methodology v2.1
              </p>
              <a
                href="javascript:void(0)"
                class="text-primary text-decoration-none small d-flex align-items-center fw-bold"
              >
                View methodology details
                <i class="fas fa-external-link-alt ms-1"></i>
              </a>
            </div>

            <!-- Source -->
            <div
              class="card shadow-sm border-0 p-3 mb-3"
              style="border-radius: 8px"
            >
              <h6 class="fw-bold text-dark mb-3">Source</h6>
              <p class="text-dark small mb-3 fw-semibold">
                Facebook Insights API
              </p>
              <a
                href="javascript:void(0)"
                class="text-primary text-decoration-none small d-flex align-items-center fw-bold"
              >
                View source details
                <i class="fas fa-external-link-alt ms-1"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Metrics Breakdown -->
      <div class="row">
        <div class="col-9 pr-0">
          <div
            class="card shadow-sm border-0 p-3 pt-4 mb-3"
            style="border-radius: 8px"
          >
            <h4 class="fw-bold text-dark mb-3">
              <strong>Metrics Breakdown</strong>
            </h4>
            <div class="table-responsive">
              <table
                class="table table-borderless table-sm small align-middle mb-0 text-start"
              >
                <thead class="text-dark border-bottom head-table">
                  <tr>
                    <th class="fw-semibold pb-2 pt-0 w-15">Metric</th>
                    <th class="fw-semibold pb-2 pt-0 w-25">Definition</th>
                    <th class="fw-semibold pb-2 pt-0 w-20">Formula</th>
                    <th class="fw-semibold pb-2 pt-0 w-15">Source</th>
                    <th class="fw-semibold pb-2 pt-0 w-10">Data Status</th>
                    <th class="fw-semibold pb-2 pt-0 text-end">Last Update</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="border-bottom"
                    *ngFor="let item of metricsBreakdown; let last = last"
                    [ngClass]="{ 'border-bottom-0': last }"
                  >
                    <td class="text-dark fw-semibold py-2">
                      {{ item.metric }}
                    </td>
                    <td class="text-dark fw-semibold">
                      {{ item.definition }}
                    </td>
                    <td class="text-dark">{{ item.formula }}</td>
                    <td class="text-dark">{{ item.source }}</td>
                    <td class="text-dark fw-semibold">
                      <i
                        class="fas fa-circle me-1"
                        [ngClass]="item.statusClass"
                        style="font-size: 8px"
                      ></i>
                      {{ item.status }}
                    </td>
                    <td class="text-dark text-end">
                      {{ item.lastUpdate }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- <div class="row mx-0">
                <div
                  class="col-12 px-0 d-flex justify-content-between text-muted mt-2"
                  style="font-size: 0.75rem"
                >
                  <span
                    >All results are governed by Global Performance Authority.
                    Data is verified, versioned and traceable.</span
                  >
                  <span>Performance v1.0</span>
                </div>
              </div> -->
        </div>
        <div class="col-lg-3 ps-lg-3 mt-3 mt-lg-0 px-0">
          <div class="d-flex flex-column h-100">
            <!-- Registry -->
            <div
              class="card shadow-sm border-0 p-3 mb-3"
              style="border-radius: 8px"
            >
              <h6 class="fw-bold text-dark mb-3">Registry</h6>
              <p class="text-dark small mb-3 fw-semibold">
                Facebook Page Global
              </p>
              <a
                href="javascript:void(0)"
                class="text-primary text-decoration-none small d-flex align-items-center fw-bold"
              >
                View registered object
                <i class="fas fa-external-link-alt ms-1"></i>
              </a>
            </div>

            <!-- Observability -->
            <div class="card shadow-sm border-0 p-3" style="border-radius: 8px">
              <h6 class="fw-bold text-dark mb-3">Observability</h6>
              <div
                class="d-flex align-items-center text-dark small fw-bold mb-3"
              >
                <i class="fas fa-check-circle text-success me-2"></i> No alerts
              </div>
              <a
                href="javascript:void(0)"
                class="text-primary text-decoration-none small d-flex align-items-center fw-bold"
              >
                View observability <i class="fas fa-external-link-alt ms-1"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
